function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
/* eslint-disable no-unused-vars */
import { ImmerChangeset } from 'ember-form-changeset-validations';
import { EventEmitter } from 'events';
/**
 * Changeset emitting events on set. And validating one field at a time.
 */
export default class BaseChangeset extends ImmerChangeset {
  async validateOne(key, validation) {
    // eslint-disable-next-line ember/classic-decorator-no-classic-methods
    const error = await validation(this.get(key), key, this['draftData']);
    if (error?.message) {
      return this.addError(key, error);
    }
    this.removeError(key);
  }
  constructor(data) {
    super(data);
    _defineProperty(this, "emitter", new EventEmitter());
  }
  onSet(fn) {
    return this.emitter.on('set', fn);
  }
  set(key, value) {
    super.set(key, value);
    this.emitter.emit('set', key);
  }

  /**
   * Updates draft data without emitting the `set` event,
   * so reactive field validation is not triggered.
   */
  setSilent(key, value) {
    super.set(key, value);
  }
}